package pl.decks.personal.pages.blog

import pl.decks.personal.components.layouts.blog.BlogPostData

data class BlogPostEntry(
    val route: String,
    val blogPostData: BlogPostData,
)
